///<reference path="../../../node_modules/@types/jquery/index.d.ts"/>
///<reference path="../../../node_modules/@types/jqueryui/index.d.ts"/>

$('.modal-dialog').draggable({
    handle: '.modal-header'
});
